import React from "react";
import styles from "./CustomCheckboxes.module.scss";
import { useRefinementList } from "react-instantsearch";
import { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import { getAllClassNames } from "helpers";
import { SortBy } from "instantsearch.js";
import { SearchResults } from "algoliasearch-helper";
import { BubbleIcon } from "components/bubbleIcon/BubbleIcon";


type ICustomCheckboxes = React.ComponentProps<"div"> & {
  title?: string;
  info?: string;
  isSingle?: boolean;
  isFlex?: boolean;
  limitWidth?: boolean;
  attribute: string;
  transformItems?: (items: RefinementListItem[]) => RefinementListItem[];
  sortBy?: SortBy<SearchResults.FacetValue>;
};

export const CustomCheckboxes = ({
  title,
  info,
  isSingle,
  attribute,
  isFlex,
  limitWidth,
  transformItems,
  sortBy,
}: ICustomCheckboxes) => {
  const { items, refine } = useRefinementList({ attribute, sortBy: sortBy});
  const itemsLength = transformItems ? transformItems(items).length : items.length;
  if (itemsLength === 0) return null;

  return (
    <fieldset className={styles.container} aria-labelledby="checkboxGroup">
      {(title && items.length > 0 && !isSingle) && <span id="checkboxGroup" className={styles.title} >{title}</span>}{info && <BubbleIcon className={styles.bubble} info={info} />}
      <div className={styles.label}></div>
      <div className={"ais-RefinementList"} >
        <ul
          className={getAllClassNames([
            "ais-RefinementList-list",
            isFlex && styles.list,
            limitWidth && styles.limitWidth,
          ])}
        >
          {(transformItems ? transformItems(items) : items).map((item) => (
            <li
              key={item.value}
              className={getAllClassNames([
                styles.item,
                "ais-RefinementList-item",
                item.isRefined && "ais-RefinementList-item--selected",
              ])}
            >
              <label className={"ais-RefinementList-label"}>
                <input
                  className={getAllClassNames([
                    "ais-RefinementList-checkbox",
                    styles.checkbox,
                  ])}
                  type="checkbox"
                  value={item.value}
                  checked={item.isRefined}
                  onChange={() => {
                    refine(item.value);
                  }}
                />
                <span
                  className={getAllClassNames([
                    "ais-RefinementList-labelText",
                    //isSingle ? styles.labelTitle : styles.labelText,
                    styles.labelText,
                  ])}
                >
                  {item.label}
                </span>
                
              </label>              
            </li>
          ))}
        </ul>
      </div>
    </fieldset>
  );
};
